__turbopack_context__.v({
  "asideList": "HDMqaW_asideList",
  "scrollContainer": "HDMqaW_scrollContainer",
});
